import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#colors" }),
  /*#__PURE__*/_createTextVNode(" Colors ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".separator"),
  /*#__PURE__*/_createTextVNode(" class in combination with "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://getbootstrap.com/docs/5.0/utilities/borders/#border-color",
    class: "fw-bold"
  }, "Bootstrap Border Color"),
  /*#__PURE__*/_createTextVNode("  classes to change separator's border color: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = { class: "py-5" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <div class="separator border-white my-10"></div>
        <div class="separator border-primary my-10"></div>
        <div class="separator border-light my-10"></div>
        <div class="separator border-secondary my-10"></div>
        <div class="separator border-success my-10"></div>
        <div class="separator border-info my-10"></div>
        <div class="separator border-warning my-10"></div>
        <div class="separator border-danger my-10"></div>
        <div class="separator border-dark my-10"></div>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "bg-dark my-10 py-5"
          }, [
            _createVNode("div", {
              class: [`border-${item}`, "separator"]
            }, null, 2)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ]))
}